import { setup as setupImages } from './images';

self.__WB_DISABLE_DEV_LOGS = true; // disable workbox logs, might enable for certain envs

setupImages();
